const faqs = [
  {
    id: 1,
    heading: 'What are the different flooring options available?',
    content:
      'Explore various flooring options such as hardwood, laminate, vinyl, tile, and concrete to find the best fit for your space in terms of durability, aesthetics, and maintenance requirements.',
  },
  {
    id: 2,
    heading: 'How is the tile installation process carried out?',
    content:
      'Learn about the step-by-step process of tile installation, including surface preparation, layout planning, adhesive application, grouting, and finishing, to ensure a seamless and professional outcome.',
  },
  {
    id: 3,
    heading: 'What materials are commonly used for paving?',
    content:
      'Discover common paving materials such as concrete, asphalt, brick, and natural stone, along with their respective characteristics, benefits, and suitability for different applications.',
  },
  {
    id: 4,
    heading: 'How can I maintain the quality of my flooring?',
    content:
      'Find out effective maintenance techniques for different types of flooring, including regular cleaning, polishing, sealing, and preventive measures to protect against wear, stains, and damage.',
  },
  {
    id: 5,
    heading: 'What should I do if my flooring gets damaged?',
    content:
      'Learn how to address common flooring issues such as scratches, dents, cracks, and stains through repair, replacement, or refinishing methods to restore the appearance and functionality of your floors.',
  },
];

export default faqs;